import React from 'react';
import './FormInput.scss';

interface Props {
  value?: string;

  error?: string;
  rows?: number;
  type?: string;
  placeholder?: string;
  textarea?: boolean;
  disabled?: boolean;

  onChange: (evt: any) => void;
}
const FormInput: React.FC<Props> = (props) => {
  const val = props.value || ''

  const showLabel = (val.length === 0)
  const [showText, setShowText] = React.useState(false)
  return (
    <div className="form-input-wrapper">
      { !props.textarea ? (
        <div className="input-wrapper">
          <input
            className={[
              "form-input",
              !showLabel ? 'active-input' : '',
              props.error ? 'error' : '',
              props.disabled ? 'disabled' : '',
              props.type === 'password' ? 'input-pass' : '',
            ].join(' ')}
            type={(showText || !props.type) ? "text" : props.type}
            placeholder={props.placeholder}
            value={val}
            onChange={props.onChange}
            disabled={props.disabled}
            inputMode={props.type === 'number' ? 'numeric' : undefined}
            pattern={props.type === 'number' ? '[0-9]*' : undefined}
            />
          { props.type === 'password' &&
            <div onClick={() => setShowText(!showText)} className="show-pass">
              {showText ? <i className="fa fa-eye-slash"></i> : <i className="fa fa-eye"></i>}
            </div>
          }
          <div className={["form-input-label", showLabel ? 'active-label' : ''].join(' ')}>{props.placeholder}</div>
        </div>
      ) : (
        <div className="input-wrapper">
          <textarea
            style={{resize: 'vertical'}}
            className={[
              "form-input",
              !showLabel ? 'active-input' : '',
              props.error ? 'error' : '',
              props.disabled ? 'disabled' : ''
            ].join(' ')}
            placeholder={props.placeholder}
            rows={props.rows}
            value={val}
            onChange={props.onChange}
            disabled={props.disabled}
          ></textarea>
          <div className={["form-input-label", showLabel ? 'active-label' : ''].join(' ')}>{props.placeholder}</div>
        </div>
      )}
      
      { props.error !== undefined &&
        <div className="form-error">{props.error}</div>
      }
    </div>
  );
}

export default FormInput;
